import api from "services/api";

// Get all holidays
export const getHolidays = async () => {
  return api.get("/v1/api/admin/holidays");
};

// Create a new holiday
export const createHoliday = async (holidayData) => {
  return api.post("/v1/api/admin/holidays", holidayData);
};

// Update a holiday
export const updateHoliday = async (holidayId, holidayData) => {
  return api.put(`/v1/api/admin/holidays/${holidayId}`, holidayData);
};

// Delete a holiday
export const deleteHoliday = async (holidayId) => {
  return api.delete(`/v1/api/admin/holidays/${holidayId}`);
};
